/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const TimeZoneEnum = {
    PUT_DATETIME_TIMEZONE: '/system/datetime/timezone',
    PUT_DATETIME_NTP: '/system/datetime/ntp',
    PUT_DATETIME: '/system/datetime',
    GET_DATETIME: '/system/datetime',
    GET_TIMEZONES: '/system/datetime/timezones'
};
